import React from 'react';
export function Footer() {
  return <footer className="bg-[#1A1A1A] text-gray-400 py-12 text-center text-sm border-t border-gray-800" data-id="element-70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <div className="text-3xl font-serif font-bold text-white tracking-tight mb-8" data-id="element-72">
          Elixir<span className="text-[#F9A825]" data-id="element-73">X</span>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-74">
          <a href="#" className="hover:text-white transition-colors" data-id="element-75">
            Política de privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-76">
            Términos
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-77">
            Contacto
          </a>
        </div>

        <p className="mb-6 text-gray-500" data-id="element-78">
          © {new Date().getFullYear()} ElixirX. Todos los derechos reservados.
        </p>

        <p className="text-xs text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-79">
          *Estas declaraciones no han sido evaluadas por la Administración de
          Alimentos y Medicamentos (FDA). Estos productos no están destinados a
          diagnosticar, tratar, curar o prevenir ninguna enfermedad.
        </p>
      </div>
    </footer>;
}